module.exports = __webpack_public_path__ + "static/img/dignwei.8732eda.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/aboutsUs/dignwei.png
// module id = MXyC
// module chunks = 1